module.exports = __webpack_public_path__ + "img/2457.ee817096.gif";